import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";

export function BuyerDetails({ form, setForm, onNext, price, testPrefix = "workshop-book" }) {
  const next = (e) => {
    e.preventDefault();
    if (!form.name || !form.email) { toast.error("Please enter your name and email."); return; }
    onNext();
  };
  return (
    <form onSubmit={next} className="space-y-4">
      <div>
        <Label htmlFor={`${testPrefix}-name`}>Full name</Label>
        <Input id={`${testPrefix}-name`} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" data-testid={`${testPrefix}-name`} />
      </div>
      <div>
        <Label htmlFor={`${testPrefix}-email`}>Email (for your receipt & recordings)</Label>
        <Input id={`${testPrefix}-email`} type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" data-testid={`${testPrefix}-email`} />
      </div>
      <label className="flex items-start gap-2.5 text-sm text-slate-600 cursor-pointer select-none">
        <input type="checkbox" checked={!!form.marketing_opt_in}
               onChange={(e) => setForm({ ...form, marketing_opt_in: e.target.checked })}
               className="mt-0.5 w-4 h-4 rounded border-slate-300 text-teal-600 focus:ring-teal-500 shrink-0"
               data-testid={`${testPrefix}-optin`} />
        <span>Email me occasional teaching tips, new resources and workshop dates. No spam, unsubscribe any time.</span>
      </label>
      <Button type="submit" className="w-full bg-teal-600 hover:bg-teal-700 rounded-full" data-testid={`${testPrefix}-submit`}>
        Continue to payment · ${price}
      </Button>
    </form>
  );
}

export default function WorkshopBookDialog({ workshop, triggerClassName, triggerLabel = "Book Now" }) {
  const { add } = useCart();
  const dateStr = new Date(workshop.date).toLocaleDateString("en-AU", { day: "numeric", month: "short" });
  return (
    <Button className={triggerClassName} data-testid={`workshop-book-trigger-${workshop.id}`}
      onClick={() => add({ item_id: workshop.id, name: workshop.title, price: workshop.price, kind: "workshop", detail: `${dateStr} · ${workshop.time}` })}>
      <ShoppingBag className="w-4 h-4" /> {triggerLabel}
    </Button>
  );
}
